import { useQuery } from "react-query"

import axios from "axios"

import { ServiceFailedToReturn, FailureMessage } from "./types"
import { customerBaseApi, removeCustomerfromSellerDeletePath } from "./utils"

// ================= Remove a customer (buyer) from a merchant (Seller)

export const useOptOutCustomer = (
  orgUuid: string,
  customerUuid: string,
  onSuccess: () => void,
) => {
  const apiCall = async () => {
    try {
      await axios.delete(
        customerBaseApi(removeCustomerfromSellerDeletePath(orgUuid, customerUuid)),
        {
          headers: {
            "Content-Type": "application/json",
          },
          validateStatus: (status: number) => status === 204,
        },
      )

      onSuccess()

      return {}
    } catch (err: any) {
      const { status } = err.response || {}
      let failureMessage

      switch (status) {
        case 400:
          failureMessage = FailureMessage.INVALID_INPUT
          break
        case 404:
          failureMessage = FailureMessage.CUSTOMER_NOT_FOUND
          break

        default:
          failureMessage = FailureMessage.OPERATION_ERROR
          break
      }
      return {
        failureMessage,
      }
    }
  }

  return useQuery<ServiceFailedToReturn, { message: string }>(
    "remove-customer",
    apiCall,
    {
      retry: 0,
      refetchOnWindowFocus: false,
      enabled: false,
    },
  )
}
